import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@stockcare-services/config-service/config.service';
import { IPerformanceAnalytics } from '@stockcare-models/IPerformanceAnalytics';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';

@Injectable({
    providedIn: 'root'
})
export class PerformanceMetricService {
    constructor(
        private http: HttpClient,
        private configuration: ConfigService,
        private deviceService: DeviceService
    ) {}

    buildAndSubmitMetrics(startDate: Date, name: string) {
        const endDate = new Date();
        const timeToExecute = endDate.getTime() - startDate.getTime();

        const device = this.deviceService.getDeviceFromLocalStorage();

        const performanceMetric: IPerformanceAnalytics = {
            name,
            deviceId: device.id,
            institutionId: device.institutionId,
            physicalLocationId: device.physicalLocationId,
            timeToExecute
        };

        this.submit(performanceMetric);
    }

    private submit(performanceAnalytics: IPerformanceAnalytics) {
        this.http
            .post<IPerformanceAnalytics>(
                `${this.configuration.config.baseUrl}/Metrics`,
                performanceAnalytics
            )
            .subscribe();
    }
}
